import React from 'react'

import DeleteIcon from '@mui/icons-material/Delete'
import RestoreIcon from '@mui/icons-material/Restore'
import CircularProgress from '@mui/material/CircularProgress'

export type ShareLoanActionsIconType =
	| 'loading'
	| 'delete'
	| 'restore'

type ShareLoanActionsIconProps = {
	contentType: ShareLoanActionsIconType
}

const ShareLoanActionsIcon = ({
	contentType,
}: ShareLoanActionsIconProps) => {
	if (contentType === 'loading') return <CircularProgress size={20} />

	return contentType === 'delete' ? <DeleteIcon /> : <RestoreIcon />
}

export default ShareLoanActionsIcon
